"use client";

import { StudioChatMockup } from "@/components/redesign/StudioChatMockup";
import type { ChatMockupBlockProps } from "@/puck/types";
import { normalizeCitationMarkerIndices } from "@/utils/chatMockup";

export function ChatMockupBlock({
  header,
  messages,
  citations,
}: Readonly<ChatMockupBlockProps>) {
  return (
    <div className="h-full min-h-[16rem]">
      <StudioChatMockup
        header={header}
        messages={messages.map((message) => ({
          ...message,
          tag: message.tag || undefined,
          citationMarkers: normalizeCitationMarkerIndices(
            message.citationMarkers,
          ),
        }))}
        citations={citations}
      />
    </div>
  );
}
